import styled from "styled-components";

import { AlertBannerBase, AlertBannerContainer } from "@runwayhealth/runway-components-react";

export const MessageBase = styled(AlertBannerBase)`
  svg {
    display: none;
  }
  grid-template-columns: none !important;
`;

export const MessageContainer = styled(AlertBannerContainer)`
  grid-template-columns: none !important;
  padding: 3px;
`;
